"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableFieldRemoveDialog = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const dialog_1 = require("../dialog/dialog");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const table_field_context_1 = require("./table-field-context");
exports.TableFieldRemoveDialog = (0, react_1.forwardRef)(function TableFieldRemoveDialog({ index }, ref) {
    const { removeRow } = (0, react_1.useContext)(table_field_context_1.TableFieldContext);
    const handleRemove = (0, event_callback_hook_1.useEventCallback)(() => {
        if (index !== undefined) {
            removeRow(index);
        }
    });
    return (react_1.default.createElement(dialog_1.Dialog, { ref: ref, title: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_TABLE_FIELD_REMOVE_DIALOG_TITLE", defaultMessage: "Smaz\u00E1n\u00ED" }), onConfirm: handleRemove, confirmLabel: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_TABLE_FIELD_REMOVE_DIALOG_BTN_DELETE", defaultMessage: "Smazat" }) }, () => (react_1.default.createElement(Typography_1.default, null,
        react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_TABLE_FIELD_REMOVE_DIALOG_MSG_CONFIRM", defaultMessage: "Jste si jisti, \u017Ee chcete smazat vybran\u00FD prvek ?" })))));
});
//# sourceMappingURL=table-field-remove-dialog.js.map